import title from '../video_assets/Maus-rockt.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/245/2459035/,2459035_35926435,2459035_35926436,2459035_35926437,2459035_35926433,2459035_35926438,2459035_35926434,.mp4.csmil/master.m3u8'

export default {
  id: '02',
  name: 'Die Band (Musik 2/5)',
  subtitle: 'Code einen Song und lasse Konfetti regnen',
  image: title,
  video: url,
}
